import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from "react-loader";
import { toast, ToastContainer } from "react-toastify";
import {
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

import AwesomeModal from "react-awesome-modal";

import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

import Navbar from "../../../../components/CustomNav/CustomNav.Component";
import SortableTable from "../../../../components/PaginationTable/PaginationTable.Component";
import withServices from "../../../../HOCs/withServices";
import { Wrapper, Content, ContentRow } from "./SingleSchool.styles";
import {
  currentBaseUrl,
  currentProfile,
  getGeneralSmartTableData,
  isUserLoggedIn,
} from "../../../../common/services";

import { StyledStep } from "../../../../components/ReactTourSteps/ReactTourSteps.styles";
interface IProps {
  services?: any;
  location?: any;
  match?: any;
  history?: any;
}

interface IState {
  toLogin: boolean;
  loaded: boolean;
  data: any;
  selectedLesson: string;
  isNavigate: boolean;
  destination: string;
  guidesRead: boolean;
  showAssignModal: boolean;
  availableAssessments: any;
  selectedUser: any;
  selectedAssessment: any;
}

const tourSteps = [
  {
    selector: ".step-1",
    content: () => (
      <StyledStep>
        <h1 className="step-title">List</h1>
        <p className="step-text">
          SL is where I put all the information you registered to your
          Performance Learning Dashboard. The first four columns show fixed
          information such as username, assessment status and unique Performance
          Learning codes. The last columns are details of data you added. By
          default, I list these as field, 1, 2, 3, 4, 5 but you may change the
          names in your profile.
        </p>
        {/* <p className="step-link">
          Find out more about <span>step 1</span> in the
          <span>Help Center</span>{" "}
        </p> */}
      </StyledStep>
    ),
    style: { background: "#2a2a2a" },
  },
];

class SingleSchool extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      destination: "",
      toLogin: false,
      loaded: true,
      isNavigate: false,
      data: {},
      selectedLesson: "",
      guidesRead: true,
      showAssignModal: false,
      availableAssessments: [],
      selectedUser: null,
      selectedAssessment: null,
    };

    this.onLogout = this.onLogout.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
    this.urnModalToggle = this.urnModalToggle.bind(this);
    this.urnSubmit = this.urnSubmit.bind(this);
    this.deptModalToggle = this.deptModalToggle.bind(this);
    this.deptSubmit = this.deptSubmit.bind(this);
    this.reportGenerate = this.reportGenerate.bind(this);
    this.viewMoreData = this.viewMoreData.bind(this);
    this.fetchStudents = this.fetchStudents.bind(this);
    this.fetchUserAssessments = this.fetchUserAssessments.bind(this);
    this.assignAssessmentToUser = this.assignAssessmentToUser.bind(this);
  }

  public customTD = (props) => {
    return (
      <td>
        {/*tslint:disable-next-line jsx-no-lambda*/}
        <button
          className="blue-button"
          style={{
            margin: "0 .75em .5em 0",
            padding: ".375em",
            fontSize: "16px",
          }}
          onClick={this.viewMoreData.bind(this, props)}
          disabled={props.rowData.PreAssesmentDone === "no"}
        >
          Explore
        </button>

        <button
          className="blue-button"
          style={{ margin: "0 0 .5em 0", padding: ".375em", fontSize: "16px" }}
          onClick={this.fetchUserAssessments.bind(this, props)}
          disabled={props.rowData.PreAssesmentDone === "no"}
        >
          Assign
        </button>
      </td>
    );
  };

  public onGoBack() {
    const dest = this.props.services.currentBaseUrl + "institutions";

    this.setState({
      isNavigate: true,
      destination: dest,
    });
  }

  public viewMoreData(props) {
    // navigate to more student data
    // this.setState({navigate: true, destination: this.state.baseurl + "datacenter"});
    // this.setState({navigate: true, destination: this.state.baseurl + "viewstudentdata/" + props.rowData.id});
    const history: any = this.props.history;
    history.push(`${currentBaseUrl()}viewstudentdata/${props.rowData.id}`);
  }

  public async fetchUserAssessments(props) {
    const res =
      await this.props.services.institutionsAPI.fetchAvailableUserAssessments(
        props.rowData.id
      );
    if (res.ok) {
      this.setState({
        availableAssessments: res.data.assessments,
        showAssignModal: true,
        selectedUser: props.rowData.id,
      });
    } else {
      toast.error("There are no available assessments at this time");
    }
  }

  public selectUserAssessment = (e) => {
    this.setState({ selectedAssessment: e.target.value });
  };

  public async assignAssessmentToUser() {
    const { selectedUser, selectedAssessment } = this.state;
    const item = { user_id: selectedUser, assessment_id: +selectedAssessment };

    const res = await this.props.services.institutionsAPI.assignUserAssessment(
      item
    );
    if (res.ok) {
      toast.success("Assessment assigned successfully");
    } else {
      toast.error("This assessment could not be assigned");
    }
    this.setState({ showAssignModal: false });
  }

  public onLogout() {
    this.setState({ toLogin: true });
  }

  public async reportGenerate(row) {
    const userid = row.rowData.User__id;

    const {
      services: { isUserLoggedIn, adminAPI, currentUserID },
    } = this.props;

    const reportRes = await adminAPI.genReports(userid);

    if (reportRes.ok) {
      toast.success("Generating reports");
    }
  }

  public async componentDidMount() {
    const {
      match,
      history,
      location,
      services: { isUserLoggedIn, institutionsAPI, currentUserID },
    } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }

    const {
      params: { id: schoolID },
    } = match;

    const studentsDataKey = [
      "FullName",
      "User",
      "PreAssesmentDone",
      // "UpgradedPreAssesmentDone",
      "ParentStudentCode",
      "field_1",
      "field_2",
      "field_3",
      "field_4",
      "field_5",
      "generate",
    ];

    const studentsThead = [
      "Name",
      "Username",
      "0.5 Done",
      "Code",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_1
        : "Field-1",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_2
        : "Field-2",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_3
        : "Field-3",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_4
        : "Field-4",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_5
        : "Field-5",
      "Action",
    ];

    const tourStatus = localStorage.getItem(
      `${this.props.services.currentUsername}StudentListTour`
    );
    let guidesRead = true;
    if (tourStatus === null) {
      guidesRead = false;
    }

    const membersRes = await institutionsAPI.getSchoolStudents(1, 10);

    if (membersRes.ok) {
      const students = membersRes.data.students;

      this.setState({
        data: {
          deptModal: false,
          students,
          loaded: true,
          schoolID,
          studentsDataKey,
          studentsThead,
          uploading: false,
          urnModal: false,
          pageCount: membersRes.data.page_count,
        },
        guidesRead,
      });
    } else {
      toast.error("Error fetching interaction details!");
    }
  }

  public async fetchStudents(page, size) {
    const {
      services: { institutionsAPI },
    } = this.props;
    const membersRes = await institutionsAPI.getSchoolStudents(page, size);

    if (membersRes.ok) {
      const students = membersRes.data.students;

      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          students,
          pageCount: membersRes.data.page_count,
        },
      });
    } else {
      toast.error("Error fetching interaction details!");
    }
  }

  public urnModalToggle() {
    const data = this.state.data;

    data.urnModal = !data.urnModal;

    this.setState({ data });
  }

  public deptModalToggle() {
    const data = this.state.data;

    data.deptModal = !data.deptModal;

    this.setState({ data });
  }

  public toggleAssignModal = () => {
    const { showAssignModal } = this.state;
    this.setState({ showAssignModal: !showAssignModal });
  };

  public closeTour = () => {
    localStorage.setItem(
      `${this.props.services.currentUsername}StudentListTour`,
      "true"
    );
    this.setState({ guidesRead: true });
  };

  public disableBody = (target) => {
    disableBodyScroll(target);
  };
  public enableBody = (target) => {
    enableBodyScroll(target);
  };

  public async urnSubmit(e) {
    e.preventDefault();

    const data = this.state.data;

    data.uploading = true;

    this.setState({ data });

    const fileInputElement = e.target.elements.upld;
    const formData = new FormData();

    for (const row of fileInputElement.files) {
      formData.append("files", row);
    }

    const res = await this.props.services.adminAPI.updloadUrn(
      formData,
      data.schoolID
    );

    if (res.ok) {
      const studentsRes = await this.props.services.adminAPI.getSchoolMembers(
        data.schoolID
      );

      if (studentsRes.ok) {
        const students = studentsRes.data.users;

        const data = this.state.data;

        data.students = students;

        data.uploading = false;

        data.urnModal = false;

        this.setState({ data });

        toast.success("Success");
      }
    } else {
      toast.error("Failed to complete upload");
    }

    data.uploading = false;

    this.setState({ data });
  }

  public async deptSubmit(e) {
    e.preventDefault();

    const data = this.state.data;

    data.uploading = true;

    this.setState({ data });

    const fileInputElement = e.target.elements.upld;
    const formData = new FormData();

    for (const row of fileInputElement.files) {
      formData.append("files", row);
    }

    const res = await this.props.services.adminAPI.updloadDept(
      formData,
      data.schoolID
    );

    if (res.ok) {
      const studentsRes = await this.props.services.adminAPI.getSchoolMembers(
        data.schoolID
      );

      if (studentsRes.ok) {
        const students = studentsRes.data.users;

        const data = this.state.data;

        data.students = students;

        data.uploading = false;

        data.urnModal = false;

        this.setState({ data });

        toast.success("Success");
      }
    } else {
      toast.error("Failed to complete upload");
    }

    data.uploading = false;

    this.setState({ data });
  }

  public renderAssignmentModal() {
    const { availableAssessments, showAssignModal } = this.state;
    return (
      <AwesomeModal
        visible={showAssignModal}
        onClickAway={this.toggleAssignModal}
        effect="fadeInDown"
        height="300"
        width="400"
      >
        <div
          style={{
            backgroundColor: "#1a1a1a",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: "#fff",
            padding: "1.25em",
            fontStyle: "italic",
            height: "100%",
          }}
        >
          {/* <h5 style={{ fontWeight: "bold", color: "#fff" }}>ASSIGNING ASSESSMENTS</h5> */}
          <p>Pick an assessment to assign</p>
          <div className="show-picker">
            <span>
              <select
                className="custom-select sf-select"
                onChange={this.selectUserAssessment}
                style={{ width: "320px" }}
              >
                <option value=""> -- Pick an assessment -- </option>
                {availableAssessments.map((assessment) => (
                  <option
                    key={`assess-${assessment.id}`}
                    value={+assessment.id}
                  >
                    {assessment.title}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <button
            onClick={this.assignAssessmentToUser}
            className="blue-button"
            style={{ padding: "0.5em 1em", marginTop: "1.5em", width: "300px" }}
          >
            Assign
          </button>
        </div>
      </AwesomeModal>
    );
  }
  public render() {
    const { data } = this.state;

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    if (this.state.isNavigate) {
      return <Redirect to={this.state.destination} />;
    }

    if (Object.keys(data).length === 0) {
      return <Loader color="#acff24" />;
    }

    return (
      <Wrapper>
        <ToastContainer />
        <Tour
          steps={tourSteps}
          isOpen={!this.state.guidesRead}
          onRequestClose={this.closeTour}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
          accentColor="#ff0033"
        />
        <Navbar logoutParent={this.onLogout} />
        <Content>
          <ContentRow className="single-col">
            <p className="go-back" onClick={this.onGoBack}>
              &lt; Back
            </p>
          </ContentRow>
        </Content>

        {/* <Content className="">
          <SortableTbl
            tblData={data.students}
            tHead={data.studentsThead}
            dKey={data.studentsDataKey}
            customTd={[
              {
                custd: this.customTD,
                keyItem: "generate",
                sortable: false,
              },
            ]}
            defaultCSS={false}
          />
        </Content> */}

        <Content>
          <SortableTable
            {...this.props}
            tableData={data.students}
            tableHead={data.studentsThead}
            dataKeys={data.studentsDataKey}
            apiCall={this.fetchStudents}
            pageCount={data.pageCount}
            customTd={[
              {
                custd: this.customTD,
                keyItem: "generate",
                sortable: false,
              },
            ]}
          />
        </Content>

        {this.renderAssignmentModal()}

        <Content>
          <Modal
            isOpen={data.urnModal}
            toggle={this.urnModalToggle}
            style={{ marginTop: "10%" }}
          >
            <ModalHeader toggle={this.urnModalToggle}>
              {" "}
              Students Upload
            </ModalHeader>
            <ModalBody>
              <form onSubmit={this.urnSubmit}>
                <Row>
                  <Col xs="12">
                    <input
                      id="upld"
                      type="file"
                      name="upld"
                      accept=".csv"
                      multiple={false}
                      required={true}
                    />
                  </Col>

                  <Loader color="#3EE9F7" loaded={!data.uploading}>
                    <Button
                      color="primary"
                      type="submit"
                      className="adminmodalbutton"
                    >
                      Submit
                    </Button>
                    <Button
                      onClick={this.urnModalToggle}
                      className="adminmodalbutton"
                    >
                      Cancel
                    </Button>
                  </Loader>
                </Row>
              </form>
            </ModalBody>
          </Modal>
          <Modal
            isOpen={data.deptModal}
            toggle={this.deptModalToggle}
            style={{ marginTop: "10%" }}
          >
            <ModalHeader toggle={this.urnModalToggle}>
              {" "}
              Extra Data Upload
            </ModalHeader>
            <ModalBody>
              <form onSubmit={this.deptSubmit}>
                <Row>
                  <Col xs="12">
                    <input
                      id="upld"
                      type="file"
                      name="upld"
                      accept=".csv"
                      multiple={false}
                      required={true}
                    />
                  </Col>

                  <Loader color="#3EE9F7" loaded={!data.uploading}>
                    <Button
                      color="primary"
                      type="submit"
                      className="adminmodalbutton"
                    >
                      Submit
                    </Button>
                    <Button
                      onClick={this.urnModalToggle}
                      className="adminmodalbutton"
                    >
                      Cancel
                    </Button>
                  </Loader>
                </Row>
              </form>
            </ModalBody>
          </Modal>
        </Content>
      </Wrapper>
    );
  }
}

export default withServices(SingleSchool);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/SingleSchool/SingleSchool.tsx